import {Chip, styled} from "@mui/material";

export const BarekamChipContainer = styled(Chip)(() => ({
    width: 'max-content',
    display: 'flex',
    justifyContent: 'center',
    padding: '0.125rem 0.5rem',
    alignItems: 'center',
    gap: '0.625rem',
    borderRadius: '0.25rem',
    height: 'unset',

    '& .MuiChip-label': {
        padding: 'unset'
    }
}));